
module.exports = require('./ColorPicker');
module.exports.Panel = require('./Panel');



// WEBPACK FOOTER //
// ./src/index.js